<div class="switch-test-tiers" *ngIf="_hasPermissionService.isAdmin()">
    <label for="switch-test-tiers" class="input-title">
      <span>Test tiers</span>
    </label>
    <input type="checkbox" [(ngModel)]="isTestTier" class="rp-switch"  (change)="table?.resetTable()" id="switch-test-tiers"/>
</div>
<one-card class="no-padding">
  <one-dynamic-table #table [tableData]="tiersTableData"></one-dynamic-table>
</one-card>
